module.exports = __webpack_public_path__ + "img/Blog Admin 2.0c06d24c.jpg";